module.exports = __webpack_public_path__ + "assets/img/login-app.42a432aa.png";